import script from "./SkillsoftwareView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillsoftwareView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillsoftwareView.vue?vue&type=style&index=0&id=77d645a4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d645a4"]])

export default __exports__